import { atom } from "recoil";

export const jobgingAtom = atom({
  key: "jobgingAtom",
  default: {
    username: "줍깅",
    accountname: "_jubging_",
    intro: "플로깅 경험을 향상시켜주는 플로깅 가이드, 줍깅",
    id: "6548aa78b2cb205663197f5d",
  },
});
